import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';
import {DataService, type PostgRestRoute} from '../../../api/data/DataService';

// Attribute for tag (M2M) attributes
export type TagAttributeOptions = BaseAttributeOptions & {
  tableOrigin?: string | null;
};

export class TagAttribute extends BaseAttribute {
  tableOrigin?: string | null;

  constructor(options: TagAttributeOptions = {}) {
    super(options);
    this.tableOrigin = options.tableOrigin ?? null;
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'tag';
  }

  get selectString(): string {
    if (this.tableOrigin) {
      return `${this.name}:tag!${this.tableOrigin}_tag(id,designation,colour)`;
    }
    if (this.moduleUsage === 'staff') {
      return `${this.name}:tag!staff_tag(id,designation,colour)`;
    }
    return `${this.name}:tag(id,designation,colour)`;
  }

  getInitialValue(): unknown {
    if (this.creationValue !== undefined && this.creationValue !== null) {
      return this.creationValue;
    }
    return [];
  }

  get customTableProperties(): Object {
    if (!this.tableOrigin) return {};
    let visibleColumn = this.tableOrigin;
    if (visibleColumn === 'project_part') {
      visibleColumn = 'project';
    }
    return {
      customFilters: {
        [visibleColumn + '_visible']: 'is.true',
      },
    };
  }

  toDbValue(value: unknown): [unknown, unknown] {
    if (!value) return [null, null];
    if (typeof value === 'object' && value !== null && 'id' in value) {
      const fkValue = value as {id: unknown};
      return [fkValue.id, value];
    }
    return [null, null];
  }

  /** Updates the records in the sub table (if tags via join) */
  updateSubTable(
    tagList: Record<string, unknown>[],
    tableOrigin: string,
    entityId: string,
  ) {
    const tagTable: PostgRestRoute = `${tableOrigin}_tag` as PostgRestRoute;
    DataService.delete(tagTable, {
      [tableOrigin + '_id']: 'eq.' + entityId,
    }).then(() => {
      const newTags = tagList.map((t) => ({
        [tableOrigin + '_id']: entityId,
        tag_id: t.id,
      }));
      if (newTags.length > 0) {
        DataService.create(tagTable, newTags);
      }
    });
  }
}
